<div class="layout-container">
  <ng-content></ng-content>
</div>
